// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ExpertsFromSection_Wrapper__8B9BL","ImgsWrapper":"ExpertsFromSection_ImgsWrapper__OyfDF","ImgContainer":"ExpertsFromSection_ImgContainer__XM8u4"};